var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-head"},[_c('div',[_c('img',{staticClass:"img",attrs:{"src":require("../../../images/logo.png"),"alt":""},on:{"click":function (){this$1.$router.push('/')}}})]),_c('div',{staticClass:"title"},[_vm._v("欢迎注册百生跃！")]),_c('div',{staticClass:"go-register"},[_vm._v("已有账号，立即"),_c('span',{on:{"click":_vm.login}},[_vm._v("登录")])])])}
var staticRenderFns = []

export { render, staticRenderFns }